"use client";

import { Eraser } from "lucide-react";
import { IconButton } from "../ui/icon-button";

export function ClearDocumentButton({
  compact = false,
  disabled = false,
  onClear,
}: Readonly<{
  compact?: boolean;
  disabled?: boolean;
  onClear: () => void;
}>) {
  return (
    <IconButton
      label="Clear"
      compact={compact}
      disabled={disabled}
      onClick={onClear}
    >
      <Eraser aria-hidden="true" className={compact ? "size-4" : "size-5"} />
    </IconButton>
  );
}
